import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_INDIVIDUAL_TERMINAL_ASSESSMENT,
  GET_INDIVIDUAL_TERMINAL_ASSESSMENT_LOADING,
  CLEAR_INDIVIDUAL_TERMINAL_ASSESSMENT,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";

export const getIndividualTerminalAssessment = (data) => async (dispatch) => {
  try {
    // Dispatch loading start action
    dispatch({
      type: GET_INDIVIDUAL_TERMINAL_ASSESSMENT_LOADING,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${BASE_URL}/api/terminal/individual-assessment`,
      JSON.stringify(data),
      config
    );

    dispatch({
      type: GET_INDIVIDUAL_TERMINAL_ASSESSMENT,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    // Set loading to false on error as well
    dispatch({
      type: GET_INDIVIDUAL_TERMINAL_ASSESSMENT,
      payload: null,
    });

    toast.error(
      err.response?.data?.message || "Error fetching assessment data"
    );
    return false;
  }
};

export const clearIndividualTerminalAssessment = () => {
  return {
    type: CLEAR_INDIVIDUAL_TERMINAL_ASSESSMENT,
  };
};
